import Vue from 'vue'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// import VueRouter from 'vue-router'
import App from './app.vue'

import AppRouters from './router/router.js'

import ThemeProvider from './common/provider/theme.provider.js'
import Validator from './common/plugins/validator.js'
// [ext] api inject
import ApiProvider from './common/provider/api.provider.js'

// [ext] http/axios inject
import HttpPlugIn from './common/plugins/http.js'

// [ext] helper inject
import HelperProvider from './common/provider/helper.provider.js'

// [ext] store inject
import StoreProvider from './common/provider/store.provider.js'

import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)

Vue.prototype.$theme = ThemeProvider
Vue.prototype.$http = HttpPlugIn
Vue.prototype.$api = ApiProvider
Vue.prototype.$helper = HelperProvider
Vue.use(ElementUI)

Vue.prototype.$validator = Validator

new Vue({
  el: '#app',
  router: AppRouters,
  store: StoreProvider,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js